<template>
	<div class="index">
		<div class="content">
			<div class="card-item">
				<div class="card-title fs18"><span class="card-title-text">运营工具</span>
				</div>
				<div class="entry-list">
					<div class="icon-box">
						<div @click="routerPush('/contactStatistic/index')" class="entry-item">
							<div class="img-view"><img
								src="../../assets/images/tongji.png"
								alt=""></div>
							<div class="entry-name fs12">拉新统计</div>
						</div>
						<div @click="routerPush('/channelCode/index')" class="entry-item">
							<div class="img-view"><img
								src="../../assets/images/huoma.png"
								alt=""></div>
							<div class="entry-name fs12">渠道活码</div>
						</div>
						<div class="entry-item" @click="routerPush('/contactWelcome/index')">
							<div class="img-view"><img
								src="../../assets/images/huanyingyu.png"
								alt=""></div>
							<div class="entry-name fs12">欢迎语</div>
						</div>
						<div class="entry-item" @click="routerPush('/workMoment/index')">
							<div class="img-view"><img
								src="../../assets/images/pengyouquan.png"
								alt=""></div>
							<div class="entry-name fs12">历史朋友圈</div>
						</div>
						<div class="entry-item" @click="routerPush('/medium/index')">
							<div class="img-view"><img
								src="../../assets/images/sucai.png"
								alt=""></div>
							<div class="entry-name fs12">素材库</div>
						</div>
						<div class="entry-item" @click="routerPush('/contactMessageBatchSend/index')">
							<div class="img-view"><img
								src="../../assets/images/qunfa.png"
								alt=""></div>
							<div class="entry-name fs12">客户群发</div>
						</div>
						<div class="entry-item" @click="routerPush('/roomMessageBatchSend/index')">
							<div class="img-view"><img
								src="../../assets/images/qunfa2.png"
								alt=""></div>
							<div class="entry-name fs12">客户群群发</div>
						</div>
						<div class="entry-item" @click="routerPush('/roomTemplatePull/index')">
							<div class="img-view"><img
								src="../../assets/images/laqun.png"
								alt=""></div>
							<div class="entry-name fs12">一键拉群</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card-item">
				<div class="card-title fs18"><span class="card-title-text">客户管理</span></div>
				<div class="entry-list">
					<div class="icon-box">
						<div class="entry-item" @click="routerPush('/contact/index')">
							<div class="img-view"><img
								src="../../assets/images/guanli.png"
								alt=""></div>
							<div class="entry-name fs12">客户管理</div>
						</div>
						<div class="entry-item" @click="routerPush('/contact/index')">
							<div class="img-view"><img
								src="../../assets/images/operationalTools/tips.png"
								alt=""></div>
							<div class="entry-name fs12">客户群管理</div>
						</div>
						<div class="entry-item" @click="routerPush('/contactLost/index')">
							<div class="img-view"><img
								src="../../assets/images/liushi.png"
								alt=""></div>
							<div class="entry-name fs12">流失客户</div>
						</div>
						<!--            <div class="entry-item" @click="routerPush('/sensitiveWordMonitor/index')">-->
						<!--              <div class="img-view"><img-->
						<!--                 src="../../assets/images/shezhi.png"-->
						<!--                  alt=""></div>-->
						<!--              <div class="entry-name fs12">关键词提醒</div>-->
						<!--            </div>-->
						<div class="entry-item" @click="routerPush('/contactDeleteRemind/index')">
							<div class="img-view"><img
								src="../../assets/images/tixing.png"
								alt=""></div>
							<div class="entry-name fs12">删人提醒</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card-item">
				<div class="card-title fs18"><span class="card-title-text">医生管理</span></div>
				<div class="entry-list">
					<div class="icon-box">
						<div class="entry-item">
							<div class="img-view"><img
								src="../../assets/images/yisheng1.jpg"
								alt=""></div>
							<div class="entry-name fs12">医生列表</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="logo" v-if="false">
			<img :src="icon" alt="">
			<!--      最好的开源SCRM系统-->
		</div>

		<van-tabbar v-model="active" class="tab">
			<van-tabbar-item replace to="/">
				<span>首页</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/home.png"/>
					<img v-else src="../../assets/images/home-active.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/course/index" icon="search">
				<span>课程</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/course-active.png"/>
					<img v-else src="../../assets/images/course.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/contact/index" icon="search">
				<span>客户</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/customer-active.png"/>
					<img v-else src="../../assets/images/customer.png">
				</template>
			</van-tabbar-item>
<!--			<van-tabbar-item replace to="/tool/index" icon="setting-o">-->
<!--				<span>运营工具</span>-->
<!--				<template #icon="props">-->
<!--					<img v-if="props.active" src="../../assets/images/function-active.png"/>-->
<!--					<img v-else src="../../assets/images/function.png">-->
<!--				</template>-->
<!--			</van-tabbar-item>-->
			<van-tabbar-item replace :to="userDatalt.isDealer ? '/my' : '/my?id='+userDatalt.id" icon="setting-o">
				<span>{{ userDatalt.isDealer ? '我的' : '直播课' }}</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/my-active.png"/>
					<img v-else src="../../assets/images/my.png">
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import {userCenter} from "@/api/homePage";

export default {
	data() {
		return {
			// 文字
			message: '',
			// tbas切换
			tabsChose: 0,
			active: 3,
			userDatalt: {
				name: ''
			},
			icon: ''
		}
	},
	created() {
		this.icon = require(`../../assets/images/${process.env.VUE_APP_APP_ICON}`);
		const item = JSON.parse(localStorage.getItem("userDetails"))
		if (item) {
			this.userDatalt = item
		}
		userCenter().then(res => {
			this.userDatalt = res.data.baseInfo
			if (!item) {
				localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
			} else if (item.id !== this.userDatalt.id) {
				localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
			}
		})
	},
	watch: {},
	methods: {
		routerPush(e) {
			this.$router.push(e)
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-tabbar {
	box-sizing: content-box !important;
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #F1f2f5;

	.fs18 {
		font-size: var(--base-px-18);
	}

	.fs14 {
		font-size: var(--base-px-14);
	}

	.fs12 {
		font-size: var(--base-px-12);
	}

	p {
		margin-bottom: 0 !important;
	}

	.content {
		padding: var(--base-px-24) var(--base-px-12) 0px;
	}

	.logo {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		font-size: var(--base-px-12);
		color: #bdbdbd;
		margin-top: var(--base-px-24);
		position: fixed;
		bottom: var(--base-px-57);
		margin-left:  var(--base-px--12);
		margin: 0 auto;

		img {
			width: var(--base-px-85);
			margin-bottom: var(--base-px-5);
		}
	}

	.card-item {
		width: 100%;
		margin-bottom: var(--base-px-16);
		background: #fff;
		border-radius: var(--base-px-7);
		overflow: hidden;
		padding-top: var(--base-px-16);

		.card-title {
			margin-bottom: var(--base-px-16);
			font-weight: 600;
			color: #333;
			line-height: var(--base-px-25);
			padding-left: var(--base-px-9);
			font-weight: 500;

			.card-title-text {
				position: relative;
			}
		}

		.entry-list {
			.data-statistics {
				.card {
					display: flex;
					justify-content: space-between;
					flex-direction: row;

					.client {
						background: url(data:image/png;base64,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) no-repeat 50%/contain;
						background-size: 100% 100%;
					}

					.pull {
						background: url(../../assets/images/operationalTools/background1.png) no-repeat 50%/contain;

					}

					.left {
						cursor: pointer;
						width: 50%;
						height: var(--base-px-112);
						box-sizing: border-box;
						border-radius: var(--base-px-12);
						padding: var(--base-px-12) var(--base-px-4) var(--base-px-4);

						.headline {
							padding-left: var(--base-px-8);
							display: flex;
							flex-direction: row;
							align-items: center;
							vertical-align: middle;

							p {
								margin-left: var(--base-px-4);
								font-weight: 400;
								color: #545454;
								padding-top:  var(--base-px-1);
							}

							.icon {
								color: rgba(84, 84, 84, 0.39);
								font-size: var(--base-px-12);
							}

							img {
								width: var(--base-px-16);
								height: var(--base-px-16)
							}
						}

						.data-info {
							margin-top: var(--base-px-12);
							width: 100%;
							height: var(--base-px-68);
							background: #fff;
							border-radius: var(--base-px-8);
							opacity: .85;
							display: flex;
							padding: var(--base-px-14) var(--base-px-4) var(--base-px-10) var(--base-px-12);

							.desc {
								.title {
									font-weight: 400;
									color: #545454;
									line-height: var(--base-px-20);
								}

								.data {
									display: flex;
									font-weight: 700;
									color: #000;
									line-height: var(--base-px-22);
									margin-top: var(--base-px-2);
								}
							}
						}
					}

					.right {
						cursor: pointer;
						margin-left: var(--base-px-11);
						padding: var(--base-px-10) var(--base-px-12);
						box-sizing: border-box;
						width: 50%;
						height: var(--base-px-112);
						background: #fff;
						border-radius: var(--base-px-12);

						.headline {
							display: flex;
							flex-direction: row;
							align-items: center;
							vertical-align: middle;

							img {
								width: var(--base-px-30);
								height: var(--base-px-30);
							}

							.name {
								margin-left: var(--base-px-6);
								font-weight: 400;
								color: #545454;
								line-height: var(--base-px-16);
							}
						}

						.tips {
							margin: var(--base-px-12) 0 var(--base-px-2);
							font-weight: 500;
							color: #333;
							line-height: var(--base-px-20);
						}

						.btn {
							display: flex;
							align-items: center;
							font-weight: 400;
							color: #2b60dd;
							height: var(--base-px-22);

							.icon {
								color: rgb(43, 96, 221);
								font-size: var(--base-px-12);
							}
						}
					}
				}
			}

			.icon-box {
				margin-top: var(--base-px-12);
				background: #fff;
				border-radius: var(--base-px-12);
				padding-top: var(--base-px-16);
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				.entry-item {
					position: relative;
					width: 25%;
					text-align: center;
					margin-bottom: var(--base-px-26);
					cursor: pointer;

					.img-view {
						display: inline-block;
						position: relative;

						img {
							display: inline-block;
							width: var(--base-px-25);
							height: var(--base-px-25);
							margin-bottom: var(--base-px-4);
						}
					}

					.entry-name {
						line-height: var(--base-px-18);
						font-weight: 400;
						color: #4e5565;
					}
				}
			}
		}
	}
}
</style>
